import { format, getHours, setHours } from 'date-fns';
import { useMemo, useState } from 'react';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { targetIsInput } from 'shared/utils/target-is-input';

export const useTodayScrollTime = (enabled = true, callback?: () => void) => {
  const [time, setTime] = useState(new Date());

  useKeysDown(
    ['KeyT'],
    (e) => {
      if (!enabled || targetIsInput(e.target)) {
        return; // Don't do a thing
      }

      // don't trigger when a context-menu is open
      if (document.querySelector('[data-interaction-for-type="task"]')) {
        return;
      }

      setTime(new Date());
      callback?.();
    },
    { otherKeysInCombinationAllowed: true },
  );

  const scrollTime = useMemo(() => {
    const hours = getHours(time);
    const adjustedTime = setHours(time, Math.max(0, hours - 3));
    return format(adjustedTime, 'HH:mm:ss');
  }, [time]);

  return { scrollTime, time };
};
